<template>
  <v-card>
    <v-toolbar flat>
      <span class="headline">More Details</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="correctionReasonsData"
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:item.category="{ item }">
              <td>{{ assist.tool.getEnumTextByValue(assist.dataType.LoanCorrectionReasonEnum, item.category) }}</td>
            </template>
            <template v-slot:item.subCategory="{ item }">
              <td>{{ assist.tool.getEnumTextByValue(assist.dataType.LoanCorrectionReasonEnum, item.subCategory) }}</td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions class="footer">
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="hideDialog">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DataType, Tool } from '@/util/index'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'

export default {
  name: 'correction-reasons-more-details-dialog',
  props: {
    correctionReasonsData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      assist: {
        tool: new Tool(),
        dataType: DataType
      },
      headers: LIST_TABLE_HEADER.CorrectionReasonsMoreDetailsHeader
    }
  },
  methods: {
    hideDialog () {
      this.$emit('hideDialog')
    }
  }
}
</script>
